import { Table } from "common/Table/Table"
import { useDebounce } from "hooks/useDebounce"
import { formatPhone } from "pages/Contacts"
import React, { useEffect, useState } from "react"
import UserService from "services/user.service"
import { useWeeklyTrainingEcardsApi } from "contexts/WeeklyTrainingEcardsContext"
import { exportToCSV, formatDate } from "utils/funcs"

const service = new UserService()

export const RaffleWinners = () => {
  const columns = [
    { key: "first_name", dbColName: "first_name", title: "first name" },
    { key: "last_name", dbColName: "last_name", title: "last name" },
    {
      key: "phone",
      dbColName: "phone",
      title: "phone",
      render: (phone) => formatPhone(phone),
    },
    {
      key: "email",
      dbColName: "email",
      title: "email",
      render: (email) => email || "-",
    },
    {
      key: "tenure",
      dbColName: "tenure",
      title: "tenure",
      render: (tenure) => (tenure ? tenure : "Guest"),
    },
    {
      key: "training_location",
      title: "training location",
      render: (row: any) => row?.training?.location || "-",
    },
    {
      key: "training_title",
      title: "training title",
      render: (row: any) => row?.training?.title || "-",
    },
    { key: "training_id", dbColName: "training_id", title: "training id" },
    { key: "created_at", dbColName: "createdAt", title: "created at", render: (date) => formatDate(date) },
  
  ]

  const [data, setData] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [totalItems, setTotalItems] = useState(0)
  const [exporting, setExporting] = useState(false)
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 100,
    isDownload: "false",
    fullName: "",
    status: "",
    date: "YEARTODATE",
  })

  const debounced = useDebounce(pagination, 1000)
  const ecardsWeekly = useWeeklyTrainingEcardsApi()

  useEffect(() => {
    setLoading(true)
    service
      .getRaffleWinners({ useEcardsVivint: ecardsWeekly })
      .then((resp) => {
        if (resp.data.success) {
          setData(resp.data.data)
          setTotalItems(resp.data.total)
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [debounced, ecardsWeekly])

  const handleExport = () => {
    setExporting(true)
    const pagin: any = { ...pagination, isDownload: "true" }
    delete pagin.pageNumber
    delete pagin.pageSize
    service
      .getAttendees(pagin, { useEcardsVivint: ecardsWeekly })
      .then((resp) => {
        exportToCSV(resp.data.raffle, "attendees")
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setExporting(false)
      })
  }

  return (
    <Table
      data={data}
      loadingData={loading}
      pagination={pagination}
      exporting={exporting}
      handleExport={handleExport}
      setPagination={setPagination}
      setData={setData}
      totalItems={totalItems}
      showSearch={false}
      columns={columns}
    //   filters={
    //     <div className="flex gap-4 flex-1">
    //       <div className="relative flex-1">
    //         <input
    //           type="search"
    //           placeholder="Full Name..."
    //           value={pagination.fullName}
    //           onChange={(e) =>
    //             setPagination({ ...pagination, fullName: e.target.value })
    //           }
    //           className="w-full px-3 py-2 text-sm"
    //         />
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           fill="none"
    //           viewBox="0 0 24 24"
    //           strokeWidth={1.5}
    //           stroke="currentColor"
    //           className="w-4 h-4 absolute text-ink-muted right-3 top-1/2 -translate-y-1/2 pointer-events-none"
    //         >
    //           <path
    //             strokeLinecap="round"
    //             strokeLinejoin="round"
    //             d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
    //           />
    //         </svg>
    //       </div>
    //       <div className="flex-1">
    //         <select
    //           onChange={(e) =>
    //             setPagination({ ...pagination, status: e.target.value })
    //           }
    //           className="w-full px-3 py-2 text-sm"
    //         >
    //           <option value="">Select</option>
    //           <option value="Deny">Deny</option>
    //           <option value="Follow-up">Follow-up</option>
    //           <option value="Hire">Hire</option>
    //           <option value="Attended">Attended</option>
    //         </select>
    //       </div>

    //       <select
    //         value={pagination.date}
    //         onChange={(e) => {
    //           if (e.target.value !== "CUSTOM") {
    //             setPagination({ ...pagination, date: e.target.value })
    //           } else {
    //             setShowCustom(true)
    //           }
    //         }}
    //         className="flex-1 px-3 py-2 text-sm"
    //       >
    //         {TAGS.map((item) => (
    //           <option key={item} value={item}>
    //             {item}
    //           </option>
    //         ))}
    //       </select>
    //       {showCustom && (
    //         <DatePicker
    //           selected={startDate}
    //           placeholderText="Select range"
    //           onChange={handleChangeDates}
    //           startDate={startDate}
    //           endDate={endDate}
    //           isClearable
    //           className="z-100 ml-2 py-2 w-60"
    //           customInput={
    //             <input
    //               placeholder="Select date"
    //               className="w-60 px-3 py-2 text-sm"
    //             />
    //           }
    //           selectsRange
    //           selectsDisabledDaysInRange
    //         />
    //       )}
    //     </div>
    //   }
      // columnFilters={
      //   <ColumnFilters pagination={pagination} setPagination={setPagination} />
      // }
    />
  )
}
